export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_08_blank.87dd2775.png";